<template>
    <section class="m-single-post-content">
        <div class="page-content">
            <div
                v-if="headers && headers.length"
                class="page-content__content-navigation"
            >
                <div class="content-navigation">
                    <div class="content-navigation__header">
                        <h2>
                            {{ $t('blog.page_contents_title') }}
                        </h2>
                    </div>
                    <div class="content-navigation__titles">
                        <div
                            v-for="(header, i) in headers"
                            :key="i"
                            @click="header.scrollIntoView({behavior:'smooth', block:'center'})"
                            v-html="header.outerHTML"
                        />
                    </div>
                </div>
            </div>

            <div
                ref="postContentEditor"
                class="page-content__text-editor"
            >
                <y-page-content
                    v-if="textEditor"
                    id="blog-text-editor"
                    :content="textEditor"
                />
            </div>
        </div>
    </section>
</template>

<script >

    import { YPageContent } from '@groot-components/all';

    export default {
        name      : 'BlogSinglePostContent',
        components: { YPageContent },
        /**
         *
         * @inheritDoc
         */
        props     : {
            textEditor: {
                type: String,
            },
            headers: Array,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            /**
             *
             * Import Headers
             *
             * @returns {Array | null} headers
             */
            importHeaders() {
                const h = document.getElementById('blog-text-editor');
                return Array.from(h.querySelectorAll('h2, h3'));
            },

            /**
             *
             * Find page offset of page-content-editor component
             *
             * @returns {number}
             */
            bannerTopMargin() {
                return this.$refs.postContentEditor.getBoundingClientRect().top - 129;
            },

        },
    };

</script>

<style lang="scss" src="./single-post-content.scss"/>
